<template>
  <modal-template
    ref="modal"
    size="lg"
    title="Enviar notificação de novos arquivos"
    :type-modal="MODAL_TYPE"
  >
    <div class="modal-content__main">
      <d-form>

        <d-form-row>
          <!-- Message -->
          <d-col md="12" class="form-group">
            <label>E-mail</label>
            <d-form-input type="email" id="feInputFooter" v-model="model.email" />
          </d-col>
        </d-form-row>

        <d-form-row>
          <!-- Message -->
          <d-col md="12" class="form-group">
            <label>Mensagem de envio</label>
            <editor ref="recibo" :model.sync="model.sendMessage"/>
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="send()"
        class="btn btn-sm btn-primary"
      >
        Enviar
      </d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Editor from '_shared/Editor.vue';
import Events from '_utils/events';
import ModalTemplate from '_shared/Modal.vue';
import CustomerService from '_services/rest/modules/customer';
import MixinFormatMessage from '_common/mixins/FormatMessage';
import formatErrors from '_common/mixins/FormatErrors';
import { MODAL_TYPE, MODEL, _OPEN_MODAL_ } from '../CustomerModel';

export default {
  name: 'send-email',
  data() {
    return {
      MODAL_TYPE,
      loading: false,
      model: {
        email: '',
        sendMessage: '',
      },
      customer: { ...MODEL },
    };
  },
  mixins: [MixinFormatMessage, formatErrors],
  components: {
    Editor,
    ModalTemplate,
  },
  computed: {
    messages() {
      const { messages } = this.$store.state.settings;
      if (messages) {
        return messages;
      }
      return { sendMessageNewFilesUpload: '' };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getSettings',
    ]),
    formatMessages() {
      const message = this.setCustomerMessage(this.messages.sendMessageNewFilesUpload, this.customer);
      this.model.email = this.customer.email;
      this.model.sendMessage = message;
    },
    async getSettingsSystem() {
      this.setToggle({ type: 'progress', bool: true });
      try {
        await this.getSettings();
      } finally {
        this.setToggle({ type: 'progress', bool: false });
      }
    },
    send() {
      this.setToggle({ type: 'progress', bool: true });
      const params = { message: this.model.sendMessage, email: this.model.email };
      const customerId = this.customer.id;
      CustomerService.sendEmailNewFilesUpload(customerId, params)
        .then(() => {
          this.setToggle({ type: MODAL_TYPE, bool: false });
          this.activeAlert({ message: 'Notificação de novos arquivos enviada com sucesso', theme: 'success' });
        })
        .catch(this.showError)
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
  mounted() {
    Events.$on(_OPEN_MODAL_, async ({ customer, type }) => {
      if (type === MODAL_TYPE) {
        this.customer = customer;

        if (!this.$store.state.settings.messages) {
          await this.getSettingsSystem();
        }

        this.formatMessages();
      }
    });
  },
  beforeDestroy() {
    Events.$off(_OPEN_MODAL_);
  },
};
</script>

<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
